import axios from 'axios';

const API_BASE_URL = 'http://localhost:5900/api';

const authApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

authApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

authApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
 
export const authAPI = {
  login: (data) => authApi.post('/auth/login', data),
  getCurrentUser: () => authApi.get('/auth/me'),
  changePassword: (data) => authApi.post('/auth/change-password', data),
  logout: () => authApi.post('/auth/logout')
};

export default authApi;
